
import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";
class IlanReklamTarifeGetAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "IlanReklamTarifeGet";
        super(baseUrl);
    }

    getIlanReklamTarifeGet(yili: number, gelirKodu?: number, gelirAltKodu?: number) {
        return this.get("", { params: { yili: yili, gelirKodu: gelirKodu, gelirAltKodu } })

    }
}
export default new IlanReklamTarifeGetAPI();